import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="mb-4">
                <span className="text-xl font-bold" style={{ fontFamily: "var(--font-heading)" }}>
                  韩漫之家
                </span>
              </div>
              <p className="text-sm text-background-50/70 leading-relaxed">
                汇集免费韩漫大全，支持韩国漫画下拉式在线阅读。从经典到新作一应俱全，满足您对韩漫的所有期待与热爱。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">快速导航</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
                <Link to="/category/romance" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">恋爱言情</Link>
                <Link to="/category/fantasy" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">奇幻冒险</Link>
                <Link to="/category/action" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">热血动作</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">热门推荐</h4>
              <div className="flex flex-col gap-2">
                <Link to="/article/jiansheng-wang" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">剑圣王</Link>
                <Link to="/article/duzhe-yu-nvzhu" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">读者与女主的正确关系</Link>
                <Link to="/article/chong-sheng-zhi-lu" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">重生之路</Link>
                <Link to="/article/mojie-shiwusuo" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">魔界事务所</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">关于我们</h4>
              <div className="flex flex-col gap-2">
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors cursor-pointer">品牌介绍</Link>
                <span className="text-sm text-background-50/70">联系邮箱：contact@hanmanzhijia.com</span>
                <span className="text-sm text-background-50/70">客服QQ：1234567890</span>
              </div>
              <div className="flex items-center gap-3 mt-4">
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="微信" rel="nofollow">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/15 hover:bg-background-50/25 transition-colors cursor-pointer" aria-label="QQ" rel="nofollow">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background-50/50">
            <p>&copy; 2026 韩漫之家 - 免费韩漫在线阅读平台. All Rights Reserved.</p>
            <div className="flex items-center gap-4">
              <a href="#" className="hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
              <a href="#" className="hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}